import { SurveyActionBar as ReactSurveyActionBar } from 'survey-react-ui';
import { Action } from 'survey-core';

import { SurveyAction } from '../SurveyAction/SurveyAction';

export class SurveyActionBar extends ReactSurveyActionBar {
  renderElement(): any {
    if (!this.model.hasActions) return null;

    return this.renderItems();
  }

  renderItems() {
    return this.model.renderedActions.map((item: Action, itemIndex: number) => {
      return <SurveyAction item={item} key={'item' + itemIndex}></SurveyAction>;
    });
  }
}
